module.exports = __webpack_public_path__ + "img/e_2_12_g.0ed8dd28.png";